import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import Header from "../components/Header";
import ModalLoading from "../components/ModalLoading";
import {
  HEADER,
  formatPhoneNumberIndonesia,
  getDataAxios,
  logger,
} from "../utils/Utils";
import _ from "lodash";
import ModalDelete from "../components/Modal/ModalDelete";
import axios from "axios";
import CardUser from "../components/Card/CardUser";
import ButtonRequire from "../components/Button/ButtonRequire";
import CardOutlet from "../components/Card/CardOutlet";
import ModalOutlet from "../components/Modal/ModalOutlet";
import { error } from "jquery";
import ModalUser from "../components/Modal/ModalUser";
import { useMemo } from "react";
import V2MigrationBanner from "../components/Banner/V2MigrationBanner";

export default function Profile() {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("dompet_user")),
  );
  const [dataOutlet, setDataOutlet] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );
  const [users, setUsers] = useState({
    data: [],
    pages: [],
    length: 0,
    pageSelected: 0,
  });
  const [outlets, setOutlets] = useState([]);

  // state input user
  const [inputUser, setInputUser] = useState({});
  const [modalUserDetails, setModalUserDetails] = useState({
    title: "Add User",
    type: "Add",
  });
  const [validationUsers, setValidationUsers] = useState({
    email: {
      validate: true,
      message: "",
    },
    phone: {
      validate: true,
      message: "",
    },
    general: {
      validate: true,
      message: "",
    },
  });

  // state input outlet
  const [inputOutlet, setInputOutlet] = useState({});
  const [modalOutletDetails, setModalOutletDetails] = useState({
    title: "Add Outlet",
    type: "Add",
  });

  const [optionsData, setOptionsData] = useState({
    outlets: [],
    banks: [],
  });
  const [dataOutletKartini] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );
  const [isBannerShow, setIsBannerShow] = useState({
    renew_bank_data: false,
    disable_change_data: user.user_type === "member",
  });

  // state loading
  const [buttonLoading, setButtonLoading] = useState(false);

  // modal state
  const [showModalOutlet, setShowModalOutlet] = useState(false);
  const [showDeleteConfirmationModalUser, setShowDeleteConfirmationModalUser] =
    useState(false);
  const [
    showDeleteConfirmationModalOutlet,
    setShowDeleteConfirmationModalOutlet,
  ] = useState(false);
  const [showModalUser, setShowModalUser] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    GetAllDataRequire();
  }, []);

  useEffect(() => {
    if (showModalUser === false) {
      setInputUser({});
      setValidationUsers({
        email: {
          validate: true,
          message: "",
        },
        phone: {
          validate: true,
          message: "",
        },
        general: {
          validate: true,
          message: "",
        },
      });
    }
  }, [showModalUser]);

  const columns = {
    users: useMemo(
      () => [
        {
          Header: "Name",
          accessor: "user_name",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "Email",
          accessor: "user_email",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
        {
          Header: "Phone Number",
          accessor: "user_mobile",
          Cell: ({ value }) => <div className="text-center">{value}</div>,
        },
      ],
      [],
    ),
  };

  async function GetAllDataRequire() {
    // validate user only user admin or master
    if (user.user_type !== "member") {
      try {
        // get data bank account
        try {
          const bank_account_res = await getDataAxios(
            `${process.env.REACT_APP_BASE_URL_API}/bankAccount?channel_id=${dataOutlet.channel_id}`,
          );
          // check if bank account data exists
          if (bank_account_res.data.data[0]) {
            let bank = bank_account_res.data.data[0];
            // set to state user detail bank data
            setUser((prevState) => ({
              ...prevState,
              bank_account_id: bank.bank_account_id,
              bank_name: bank.bank_name,
              bank_number: bank.bank_number,
              holder_name: bank.holder_name,
            }));
            // set logic show banner require renew bank data
            setIsBannerShow((prevState) => ({
              ...prevState,
              renew_bank_data: _.isEmpty(bank),
            }));
          }
        } catch (error) {
          console.error(error);
        }
        // get list outlets
        let res = await getDataAxios(
          `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini?channel_id=${dataOutletKartini.channel_id}`,
        );
        // set state options data
        setOptionsData((prevState) => ({
          ...prevState,
          outlets: res.data.data.map((value) => ({
            label: value.outlet_kartini_name,
            value: value.outlet_kartini_id,
          })),
        }));

        await GetDataUsers();
        await GetDataOutlets();
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function GetDataOutlets() {
    setShowModalLoading(true);
    try {
      let list_outlets = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini?channel_id=${dataOutletKartini.channel_id}`,
        { headers: HEADER },
      );
      list_outlets = list_outlets.data.data;
      setOutlets(list_outlets);
    } catch (error) {
      console.error(error);
      setShowModalLoading(false);
    }
    setShowModalLoading(false);
  }

  async function GetDataUsers() {
    setShowModalLoading(true);
    try {
      let list_users = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/v2/collection/akuisisi/data?channel_id=${dataOutletKartini.channel_id}`,
        { headers: HEADER },
      );
      list_users = list_users.data.data;
      list_users = list_users.filter((value) => value.user_type === "member");

      var pages = [];
      for (let i = 0; i < Math.ceil((list_users.length - 1) / 10); i++) {
        pages.push(i + 1);
      }

      setUsers({
        data: list_users,
        pages: pages,
        length: list_users.length,
        pageSelected: 0,
      });
    } catch (error) {
      console.error(error);
      setShowModalLoading(false);
    }
    setShowModalLoading(false);
  }

  async function Save() {
    // PUT ADMIN
    await fetch(
      `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${user.akuisisi_id}`,
      {
        method: "PUT", // or 'PUT'
        headers: HEADER,
        body: JSON.stringify({
          ...user,
          user_mobile:
            user.user_mobile.charAt(0) === "0" ||
            user.user_mobile.charAt(0) === "+"
              ? "62" + user.user_mobile.substring(1)
              : user.user_mobile.substring(0, 2) === "62"
                ? user.user_mobile
                : "62" + user.user_mobile,
        }),
      },
    ).catch(() => console.error(error));

    await fetch(
      `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${user.akuisisi_id}`,
      {
        method: "GET", // or 'PUT'
        headers: HEADER,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("dompet_user", JSON.stringify(data.data));
      })
      .catch((error) => console.error(error));

    if (user.bank_account_id) {
      // PUT BANK ACCOUNT
      await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/bankAccount/${user.bank_account_id}`,
        {
          method: "PUT", // or 'PUT'
          headers: HEADER,
          body: JSON.stringify({
            holder_name: user.holder_name,
            bank_name: user.bank_name.toUpperCase(),
            bank_number: user.bank_number,
            outlet_kartini_id: user.outlet_kartini_id,
            akuisisi_id: user.akuisisi_id,
          }),
        },
      ).catch(() => console.error(error));
    } else {
      // POST BANK ACCOUNT
      await fetch(`${process.env.REACT_APP_BASE_URL_API}/bankAccount`, {
        method: "POST", // or 'PUT'
        headers: HEADER,
        body: JSON.stringify({
          holder_name: user.holder_name,
          bank_name: user.bank_name.toUpperCase(),
          bank_number: user.bank_number,
          outlet_kartini_id: user.outlet_kartini_id,
          akuisisi_id: user.akuisisi_id,
        }),
      }).catch((error) => console.error(error));
    }
    GetAllDataRequire();
  }

  function ShowEditModal(data) {
    setInputUser(data);
    setShowModalUser(true);
    setModalUserDetails({
      title: "Edit User",
      type: "Edit",
    });
  }

  function ShowDeleteModal(id) {
    setModalUserDetails({
      title: "Delete User",
      type: "Delete",
      id: id,
    });
    setShowDeleteConfirmationModalUser(true);
  }

  function ValidationEmailUsed() {
    setValidationUsers((prevState) => ({
      ...prevState,
      email: {
        validate: false,
        message: "Email already in use",
      },
    }));
  }
  function ValidationPhoneUsed() {
    setValidationUsers((prevState) => ({
      ...prevState,
      phone: {
        validate: false,
        message: "Phone number already in use",
      },
    }));
  }

  function GetDefaultPhoneValidation() {
    setValidationUsers((prevState) => ({
      ...prevState,
      phone: {
        validate: true,
        message: "",
      },
    }));
  }

  function GetDefaultEmailValidation() {
    setValidationUsers((prevState) => ({
      ...prevState,
      email: {
        validate: true,
        message: "",
      },
    }));
  }

  const ValidationUsers = async (type) => {
    let validation = {
      email: true,
      phone: true,
    };

    try {
      // check if the user email is already existing
      let request_validation_email = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/akuisisi?user_email=${inputUser.user_email}`,
        { headers: HEADER },
      );
      request_validation_email = request_validation_email.data.data;
      // check if the user phone is already existing
      let request_validation_phone = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/akuisisi?user_mobile=${inputUser.user_mobile}`,
        { headers: HEADER },
      );
      request_validation_phone = request_validation_phone.data.data;

      // validation to edit data
      if (type === "edit") {
        // retrieve user data before changes
        let request_user = await axios.get(
          `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${inputUser.akuisisi_id}`,
          { headers: HEADER },
        );
        let response_user = request_user.data.data;

        let email = !_.isEmpty(request_validation_email)
          ? request_validation_email[0].user_email
          : null;
        let phone = !_.isEmpty(request_validation_phone)
          ? request_validation_phone[0].user_mobile
          : null;

        // condition to check the user's email has changed from before and the changed email is already in use
        if (response_user.user_email !== email && !_.isEmpty(email)) {
          validation = {
            ...validation,
            email: false,
          };
          ValidationEmailUsed();
        } else {
          GetDefaultEmailValidation();
        }
        // condition to check the user's phone changed from before and the changed phone is already in use
        if (response_user.user_mobile !== phone && !_.isEmpty(phone)) {
          validation = {
            ...validation,
            phone: false,
          };
          ValidationPhoneUsed();
        } else {
          GetDefaultPhoneValidation();
        }
      } else {
        if (!_.isEmpty(request_validation_email)) {
          validation = {
            ...validation,
            email: false,
          };
          ValidationEmailUsed();
        } else {
          GetDefaultEmailValidation();
        }
        if (!_.isEmpty(request_validation_phone)) {
          validation = {
            ...validation,
            phone: false,
          };
          ValidationPhoneUsed();
        } else {
          GetDefaultPhoneValidation();
        }
      }
    } catch (error) {
      console.error(error);
    }
    return validation;
  };

  const AddUser = async () => {
    setShowModalLoading(true);
    try {
      let validation = await ValidationUsers();
      // if email or phone number is not registered
      if (validation.email && validation.phone) {
        await axios
          .post(
            `${process.env.REACT_APP_BASE_URL_API}/akuisisi`,
            {
              channel_id: dataOutletKartini.channel_id,
              outlet_kartini_id: inputUser.outlet_kartini_id,
              user_name: inputUser.user_name,
              user_email: inputUser.user_email,
              user_mobile: formatPhoneNumberIndonesia(inputUser.user_mobile),
              user_type: "member",
              status: "active",
            },
            { headers: HEADER },
          )
          .catch((error) => {
            setValidationUsers((prevState) => ({
              ...prevState,
              general: {
                validate: false,
                message: "Failed to add member",
              },
            }));
            console.error(error);
          });
        setShowModalUser(false);
        // Update Member
        await GetDataUsers();
      }
    } catch (error) {
      console.error(error);
    }
    setShowModalLoading(false);
  };

  async function DeleteUser() {
    setButtonLoading(true);
    let id = modalUserDetails.id;
    try {
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${id}`,
        {
          headers: HEADER,
        },
      );
      // Update Member
      await GetDataUsers();
    } catch (error) {
      setValidationUsers((prevState) => ({
        ...prevState,
        general: {
          validate: false,
          message: "Failed to delete member",
        },
      }));
      console.error(error);
    }

    setButtonLoading(false);
    setShowDeleteConfirmationModalUser(false);
  }

  async function EditUser(body) {
    setShowModalLoading(true);

    try {
      let validation = await ValidationUsers("edit");

      if (validation.email && validation.phone) {
        await axios.put(
          `${process.env.REACT_APP_BASE_URL_API}/akuisisi/${body.akuisisi_id}`,
          {
            outlet_kartini_id: body.outlet_kartini_id,
            user_name: body.user_name,
            user_email: body.user_email,
            user_mobile: formatPhoneNumberIndonesia(body.user_mobile),
            user_type: "member",
          },
          { headers: HEADER },
        );
        setShowModalUser(false);
        // Update Member
        await GetDataUsers();
      }
    } catch (error) {
      setValidationUsers((prevState) => ({
        ...prevState,
        general: {
          validate: false,
          message: "Failed to edit member",
        },
      }));
      console.error(error);
    }
    setShowModalLoading(false);
  }

  // OUTLET
  function ShowEditModalOutlet(data) {
    setInputOutlet(data);
    setShowModalOutlet(true);
    setModalOutletDetails({
      title: "Edit Outlet",
      type: "Edit",
    });
  }

  async function ShowDeleteModalOutlet(id) {
    setModalOutletDetails({
      title: "Delete Outlet",
      type: "Delete",
      id: id,
    });
    setShowDeleteConfirmationModalOutlet(true);
  }

  async function AddOutlet() {
    setShowModalLoading(true);
    // field_required
    let body = {
      outlet_kartini_code: `DOMPET${generateRandomNumber()}`,
      channel_id: dataOutletKartini.channel_id,
      status: "active",
      validation_status: "to be confirmed",
      ...inputOutlet,
    };

    await axios
      .post(`${process.env.REACT_APP_BASE_URL_API}/outlet/kartini`, body, {
        headers: HEADER,
      })
      .then((res) => logger("success: ", res))
      .catch((error) => {
        console.error(error);
        setShowModalLoading(false);
      });
    GetDataOutlets();
    setShowModalOutlet(false);
    setShowModalLoading(false);
  }

  async function EditOutlet(body) {
    setShowModalLoading(true);
    await axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/outlet/kartini/${body.outlet_kartini_id}`,
        body,
        {
          headers: HEADER,
        },
      )
      .then((res) => logger("success: ", res))
      .catch((error) => {
        console.error(error);
        setShowModalLoading(false);
      });
    GetDataOutlets();
    setShowModalOutlet(false);
    setShowModalLoading(false);
  }

  async function DeleteOutlet() {
    setButtonLoading(true);
    let id = modalOutletDetails.id;
    await axios
      .delete(`${process.env.REACT_APP_BASE_URL_API}/outlet/kartini/${id}`, {
        headers: HEADER,
      })
      .then((res) => logger("success: ", res))
      .catch((error) => {
        console.error(error);
        setButtonLoading(false);
        setShowDeleteConfirmationModalOutlet(false);
      });
    GetDataOutlets();
    setButtonLoading(false);
    setShowDeleteConfirmationModalOutlet(false);
  }

  function generateRandomNumber() {
    // Generate a random number between 0 and 1 (excluding 1)
    const randomDecimal = Math.random();

    // Scale the random number to be between 1000 and 9999
    const randomNumber = Math.floor(randomDecimal * 9000) + 1000;

    return randomNumber;
  }

  // TODO: this function is used to simplify and shorten the set state validation.
  function ShowValidate(type, message) {
    setValidationUsers((prevState) => ({
      ...prevState,
      [type]: {
        validate: false,
        message: message,
      },
    }));
  }

  return (
    <>
      {!localStorage.getItem("dompet_user") ||
      !localStorage.getItem("dompet_detail_outlet") ? (
        <Navigate to="/signin" />
      ) : (
        <>
          {/* Modal Delete User */}
          <ModalDelete
            title="User"
            showDeleteConfirmationModal={showDeleteConfirmationModalUser}
            setShowDeleteConfirmationModal={setShowDeleteConfirmationModalUser}
            DeleteFunction={DeleteUser}
            buttonLoading={buttonLoading}
          />
          {/* Modal Delete Outlet */}
          <ModalDelete
            title="Outlet"
            showDeleteConfirmationModal={showDeleteConfirmationModalOutlet}
            setShowDeleteConfirmationModal={
              setShowDeleteConfirmationModalOutlet
            }
            DeleteFunction={DeleteOutlet}
            buttonLoading={buttonLoading}
          />
          {/* Modal Loading */}
          <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
          />
          {/* Modal Add Outlet */}
          <ModalOutlet
            modalOutletDetails={modalOutletDetails}
            showModal={showModalOutlet}
            setShowModal={setShowModalOutlet}
            inputOutlet={inputOutlet}
            setInputOutlet={setInputOutlet}
            dataOutlet={dataOutletKartini}
            functionAdd={AddOutlet}
            functionEdit={EditOutlet}
          />
          {/* Modal ADD USER */}
          <ModalUser
            modalUserDetails={modalUserDetails}
            showModal={showModalUser}
            setShowModal={setShowModalUser}
            inputUser={inputUser}
            setInputUser={setInputUser}
            functionAdd={AddUser}
            functionEdit={EditUser}
            dataOutlet={dataOutletKartini}
            validationUser={validationUsers}
          />

          <Header title="Profile" />
          <div className="bg-white px-4 pt-20">
            <div className="space-y-5">
              <V2MigrationBanner />
              <div className="flex justify-center">
                <div className="m-1.5">
                  {/* Start */}
                  {dataOutletKartini.channel_logo ? (
                    <img
                      className="rounded-full shadow"
                      src={dataOutletKartini.channel_logo}
                      width="100"
                      height="100"
                      alt="Avatar"
                    />
                  ) : (
                    <div className="flex items-center justify-center rounded-full bg-[#4CA6F8] px-2 py-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-24 w-24 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                  )}
                  {/* End */}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <h2 className="font-medium text-gray-700">Account</h2>
                </div>
                {/* Data Admin */}
                <div>
                  {/* <h2 className="font-medium text-gray-700">Data Admin</h2> */}
                  <form className="mt-4">
                    <div className="space-y-3">
                      <input
                        name="user_name"
                        placeholder="Name"
                        className="form-input h-12 w-full"
                        disabled
                        type="text"
                        value={user.user_name}
                        onChange={(e) =>
                          setUser((prevState) => ({
                            ...prevState,
                            [e.target.name]: e.target.value,
                          }))
                        }
                        // disabled={user.user_type === "member"}
                      />
                      <div className="relative">
                        <input
                          name="user_mobile"
                          className="form-input h-12 w-full pl-6"
                          disabled
                          type="tel"
                          value={user.user_mobile}
                          onChange={(e) =>
                            setUser((prevState) => ({
                              ...prevState,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          // disabled={user.user_type === "member"}
                        />
                        <div className="pointer-events-none absolute inset-0 right-auto flex items-center">
                          <span className="px-3 text-sm font-medium text-gray-400">
                            +
                          </span>
                        </div>
                      </div>
                      <input
                        name="user_email"
                        placeholder="Email Admin"
                        className="form-input h-12 w-full"
                        disabled
                        type="email"
                        value={user.user_email ?? ""}
                        onChange={(e) =>
                          setUser((prevState) => ({
                            ...prevState,
                            [e.target.name]: e.target.value,
                          }))
                        }
                        // disabled={user.user_type === "member"}
                      />
                    </div>
                  </form>
                </div>
              </div>

              {/* Add User */}
              {user.user_type !== "member" && (
                <>
                  <div>
                    <div className="flex items-center justify-between">
                      <h2 className="font-medium text-gray-700">
                        Bank Account
                      </h2>
                    </div>
                    {/* banner message to update bank account data if the data does not match the bank master data */}
                    {isBannerShow.renew_bank_data && (
                      <div className="mt-4">
                        <div
                          className={`flex items-center space-x-2 rounded bg-yellow-100 px-3 py-2 text-yellow-600`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-4 w-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                            />
                          </svg>
                          <span className="text-sm">
                            Please update your account bank data.
                          </span>
                        </div>
                      </div>
                    )}
                    {isBannerShow.disable_change_data && (
                      <div className="mt-4">
                        <div
                          className={`flex items-center space-x-2 rounded bg-yellow-100 px-3 py-2 text-yellow-600`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="h-4 w-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                            />
                          </svg>
                          <span className="text-sm">
                            Member account information cannot be changed by
                            member account. If you see information that seems
                            unfit/inappropriate, please contact your admin to
                            modify your desired changes.
                          </span>
                        </div>
                      </div>
                    )}

                    {/* form bank account details */}
                    <form className="mt-4">
                      <div className="space-y-3">
                        <input
                          name="bank_name"
                          placeholder="Nama Bank"
                          className="form-input h-12 w-full disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                          value={user.bank_name}
                          onChange={(e) =>
                            setUser((prevState) => ({
                              ...prevState,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          disabled
                        />
                        <input
                          name="holder_name"
                          placeholder="Nama Pemilik Rekening"
                          className="form-input h-12 w-full disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                          value={user.holder_name}
                          onChange={(e) =>
                            setUser((prevState) => ({
                              ...prevState,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          disabled
                        />
                        <input
                          name="bank_number"
                          placeholder="Nomor Rekening"
                          className="form-input h-12 w-full disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                          value={user.bank_number}
                          onChange={(e) =>
                            setUser((prevState) => ({
                              ...prevState,
                              [e.target.name]: e.target.value,
                            }))
                          }
                          disabled
                        />
                      </div>
                    </form>
                  </div>
                  {/* Add USER */}
                  <div>
                    <div className="flex items-center justify-between">
                      <h2 className="font-medium text-gray-700">Member</h2>
                      <button
                        className="btn-sm bg-[#4CA6F8] text-white disabled:bg-gray-400"
                        disabled
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowModalUser(true);
                          setModalUserDetails({
                            title: "Add User",
                            type: "Add",
                          });
                        }}
                      >
                        <svg
                          className="h-4 w-4 flex-shrink-0 fill-current opacity-50"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="ml-2">Add Member</span>
                      </button>
                    </div>
                    {/* <div>

                                    <Table
                                       data={users.data ?? []}
                                       pages={users.pages ?? []}
                                       // setPageSelected={setPageSelected}
                                       // pageSelected={
                                       //    pageSelected ? pageSelected - 1 : 0
                                       // }
                                       title="Users"
                                       columns={columns.users}
                                       // enDatepicker={true}
                                       isLoading={false}
                                       // date={dateRange}
                                       // setDate={setDateRange}
                                    />
                                 </div> */}
                    <div className="mt-4 max-h-80 overflow-y-scroll">
                      <div className="space-y-3">
                        {users.data.map((user) => (
                          <CardUser
                            data={user}
                            enActionEdit={user.user_type === "member"}
                            enActionDelete={user.user_type === "member"}
                            isDisable={true}
                            editFunction={ShowEditModal}
                            deleteFunction={ShowDeleteModal}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* Add Outlet */}
                  <div>
                    <div className="flex items-center justify-between">
                      <h2 className="font-medium text-gray-700">Outlet</h2>
                      {/* <button
                        className="btn-sm bg-[#4CA6F8] text-white"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setInputOutlet({});
                          setShowModalOutlet(true);
                          setModalOutletDetails({
                            title: "Add Outlet",
                            type: "Add",
                          });
                        }}
                      >
                        <svg
                          className="h-4 w-4 flex-shrink-0 fill-current opacity-50"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="ml-2">Add Outlet</span>
                      </button> */}
                    </div>
                    <div className="mt-4 max-h-80 overflow-y-scroll">
                      <div className="space-y-3">
                        {_.isEmpty(outlets) ? (
                          <div className="h-28 w-full border-2 border-dashed">
                            <div className="flex h-full w-full items-center justify-center space-x-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="h-5 w-5 text-gray-400"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"
                                />
                              </svg>
                              <span className="text-sm text-gray-400">
                                You don't have an outlet
                              </span>
                            </div>
                          </div>
                        ) : (
                          outlets.map((outlet) => (
                            <CardOutlet
                              data={outlet}
                              enActionEdit={true}
                              isDisable={true}
                              editFunction={ShowEditModalOutlet}
                              deleteFunction={ShowDeleteModalOutlet}
                            />
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* BUTTON GROUP */}
              <div className="flex flex-col space-y-2 pb-6">
                {user.user_type !== "member" && (
                  <ButtonRequire
                    title="SAVE"
                    functionOnClick={Save}
                    isDisabled={true}
                  />
                )}
                <button
                  className="btn-lg bg-gray-50 font-bold tracking-wider text-red-500"
                  aria-controls="basic-modal"
                  onClick={() => {
                    localStorage.clear();
                    navigate("/signin");
                  }}
                >
                  LOGOUT
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
